/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { PageBanner } from "./PageBanner";
import AnimatedNumber from "react-animated-number";
import { capitalizeFirstLetter, timeString } from "../helpers/constants";
import { colors } from "../styles/common";
const KeywordGoOut = `
	font-weight: 700;
	color: ${colors.paytmBlue};
`;
const AnimatedNumberStyle = `
	display: inline-block;
	min-width: 70px;
`;
const ELPPageBanner = ({ typeValue, displayTitle, selectedCity, timeFilter, cardCount }) => {
    if (typeValue === "physical") {
        return (<PageBanner>
				<span css={css(KeywordGoOut)}>{displayTitle}</span> in {capitalizeFirstLetter(selectedCity)}{" "}
				<span css={css(KeywordGoOut)}>{timeString(timeFilter)}</span>{" "}
				<span css={css(AnimatedNumberStyle)}>(
				{<AnimatedNumber duration={400} stepPrecision={0} value={typeValue ? cardCount[typeValue] : cardCount["all"]} component="span"/>}
				)</span>
			</PageBanner>);
    }
    else if (typeValue === "online") {
        return (<PageBanner>
				<span css={css(KeywordGoOut)}>Online {displayTitle}</span>{" "}
				<span css={css(KeywordGoOut)}>{timeString(timeFilter)}</span>{" "}
				<span css={css(AnimatedNumberStyle)}>(
				{<AnimatedNumber duration={400} stepPrecision={0} value={typeValue ? cardCount[typeValue] : cardCount["all"]} component="span"/>}
				)</span>
			</PageBanner>);
    }
    return (<PageBanner>
			<span css={css(KeywordGoOut)}>All {displayTitle}</span>{" "}
			<span css={css(KeywordGoOut)}>{timeString(timeFilter)}</span>{" "}
			<span css={css(AnimatedNumberStyle)}>(
			{<AnimatedNumber duration={400} stepPrecision={0} value={typeValue ? cardCount[typeValue] : cardCount["all"]} component="span"/>}
			)</span>
		</PageBanner>);
};
export default ELPPageBanner;
